module.exports = __webpack_public_path__ + "media/nyan5.ef14338f.mp3";